export const authdata = {
    transactions: null,
    favourites: null
}